import { FC, useCallback, useState } from 'react';
import { useUserContext } from '../../contexts/user_context';
import { Dialog } from './dialog';
import { Input } from '../common/input';
import { useAppContext } from '../../contexts/app_context';

import state_0 from '../../assets/state_0.png';
import state_1 from '../../assets/state_1.png';
import state_2 from '../../assets/state_2.png';

const PROGRESS_SIZE = 6;
const STATES = [state_0, state_1, state_2];

export const LoginDialog: FC = () => {
    const [email, set_email] = useState<string>('');
    const [password, set_password] = useState<string>('');
    const [error_message, set_error_message] = useState<string>('');
    const [progress, set_progress] = useState<number[]>(Array(PROGRESS_SIZE).fill(0));
    const { login } = useUserContext();
    const { cancel_action } = useAppContext();

    const update_progress = (kind: string, value: string) => {
        const length = kind === 'email' ? (password + value).length : (email + value).length;
        const step = Math.ceil(8 / PROGRESS_SIZE);
        const new_progress = [...progress];

        for (let i = 0; i < PROGRESS_SIZE; i++) {
            const level = Math.min(2, Math.floor((length - i * step) / step));
            new_progress[i] = level >= 0 ? level : 0;
        }

        set_progress(new_progress);
    };

    const on_login = useCallback(async () => {
        const action_result: boolean | string = await login(email.trim().toLowerCase(), password.trim());
        
        if (typeof action_result === 'string') {
            set_error_message(action_result);
        } else if (action_result) {
            cancel_action();
        }
    }, [email, password, login, cancel_action]);

    return (
        <Dialog title='Login' onClose={cancel_action}>
            <div className='field-progress-wrap'>
                {progress.map((number, index) => (
                    <img alt='' src={STATES[number]} key={index} />
                ))}
            </div>
            <div className='auth-dialog'>
                <Input
                    label='Email'
                    id='email'
                    value={email}
                    onChange={(event) => {
                        set_email(event.target.value);
                        update_progress('email', event.target.value);
                    }}
                />
                <Input
                    label='Password'
                    type='password'
                    id='password'
                    value={password}
                    onChange={(event) => {
                        set_password(event.target.value);
                        update_progress('password', event.target.value);
                    }}
                />
                {error_message && <p className='error-message text-red'>{error_message}</p>}
                <button className='primary-button' onClick={on_login} disabled={!email.trim() || !password.trim()}>
                    Login
                </button>
            </div>
        </Dialog>
    );
};
